import type { JSX } from "react";
import type { Palette, PaletteColor } from "@mui/material";
import type { NavItemProps } from "./nav-item/nav-item";
import { AppBar, css, styled } from "@mui/material";
import { useBreakpoint } from "../../../theme/media-queries";
import { NavBanner } from "./nav-banner";
import { NavMenuCollapsed } from "./nav-menu-collapsed";
import { NavMenuInline } from "./nav-menu-inline";
import { NavSubMenuControllerProvider } from "./nav-sub-menu-controller";


let navPaletteKey: keyof Palette = "dark";
if(process.env["DEPLOY_ENV"] === "dev" && process.env["NODE_ENV"] !== "development") {
	navPaletteKey = "warning";
}

const NavBarRoot = styled(AppBar)(({ theme }) => css`
	display: flex;
	flex-direction: row;
	justify-content: center;

	--navBg: ${(theme.palette[navPaletteKey] as PaletteColor).main};
	--navColor: ${(theme.palette[navPaletteKey] as PaletteColor).contrastText};

	background-color: var(--navBg);
	color: var(--navColor);

	nav {
		display: flex;
		justify-content: space-between;
		
		height: ${theme.layout.navBarHeight};
		width: 100%;
		max-width: ${theme.layout.contentMaxWidth};
		
	}

	.navMenuInline > .navButton {
		font-size: .9rem;
		text-transform: uppercase;
		padding-left: ${theme.spacing(2)};
		padding-right: ${theme.spacing(2)};
	}

	.navBar__content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navBar__banner {
		height: 100%;
	}
`);

export type NavBarProps = {
	items: readonly NavItemProps[];
};
export const NavBar = ({ items }: NavBarProps): JSX.Element => {
	const large = useBreakpoint(1100);

	return (
		<NavBarRoot elevation={ 1 }>
			<nav>
				<div className="navBar__banner">
					<NavBanner/>
				</div>
				<NavSubMenuControllerProvider>
					{ large
						? <NavMenuInline className="navMenuInline" items={ items }/>
						: <NavMenuCollapsed items={ items }/>
					}
				</NavSubMenuControllerProvider>
			</nav>
		</NavBarRoot>
	);
};
